import {Alert} from 'components/system/alert';
import {CheckmarkIcon, CloseIcon} from 'icons';
import {Upsell} from 'users/upsell';
import styles from './code_run_display.module.css';
import {Summary} from './summary';
import {TestCaseResult} from './test_case_result';

export const CodeRunDisplay = ({codeRunResponse, collapsed = false, showUpsell = true}: Props) => {
  const {success, message, summary, test_cases} = codeRunResponse;

  const isPlayground = test_cases?.find((tc) => tc.playground);
  return (
    <div className={styles.container}>
      {!isPlayground && (
        <>
          <Alert
            type={success ? 'success' : 'error'}
            icon={success ? <CheckmarkIcon color='white' /> : <CloseIcon color='white' />}>
            {message}
          </Alert>
          {summary && <Summary summary={summary} />}
        </>
      )}
      {test_cases?.map((testCase, index) => (
        <TestCaseResult key={index} index={index} testCase={testCase} collapsed={collapsed} />
      ))}
      {showUpsell && <Upsell cta='question.codeRuns' barrier={false} />}
    </div>
  );
};

type Props = {
  codeRunResponse: CodeRunResponse;
  collapsed?: boolean;
  showUpsell?: boolean;
};
